// extracted by mini-css-extract-plugin
export var askAiIcon = "_qq-9";
export var container = "_qq-0";
export var groupSeparator = "_qq-a";
export var highlight = "_qq-4";
export var resultIcon = "_qq-5";
export var resultItem = "_qq-7";
export var resultSubtitle = "_qq-3";
export var resultTitle = "_qq-2";
export var resultsList = "_qq-1";
export var searchGroup = "_qq-6";
export var selected = "_qq-8";